import { Fragment, useState, useEffect } from 'react'
import classnames from 'classnames'

import profile from 'scripts/components/user/profile'

import Icon from 'reactUtils/Icon'

const User = () => {
  const [opened, setOpened] = useState(false)
  const [userResources, setUserResources] = useState({})
  const [isLoggedIn, setIsLoggedIn] = useState(false)

  const userClasses = classnames(
    'menu-list-mobile-user',
    {
      'is-opened': opened
    }
  )

  useEffect(() => {
    const getProfile = async () => {
      const userInfo = await profile.get()
      setUserResources(userInfo)
    }

    getProfile()
  }, [])

  useEffect(() => {
    const checkIfUserIsLoggedIn = async () => {
      const isUserLogged = await profile.isLoggedIn()

      setIsLoggedIn(isUserLogged)
    }

    checkIfUserIsLoggedIn()
  }, [userResources])

  const toggleOpen = () => {
    setOpened(!opened)
  }

  const redirectUrl = (target) => {
    const currentUrl = encodeURIComponent(window.location.href)

    window.sessionStorage.removeItem('userInfo')
    window.location = `/${target}?redirect=${currentUrl}`
  }

  const renderPicture = () => {
    if (userResources && userResources.picture) {
      return (
        <figure className="picture">
          <img src={ userResources.picture } alt={ `Thumbnail de ${userResources.name}` } />
        </figure>
      )
    } else {
      return <Icon icon="user" name="picture-default" />
    }
  }

  const renderLoggIn = () => (
    <Fragment>
      <span className="menu-list-mobile-block is-name">
        { renderPicture() }
        <span>
          <span className="name">{ userResources.name }</span>
          <span className="account">
            <a href={ userResources.user_url }>Minha conta</a>
          </span>
        </span>
      </span>
      <span className="menu-list-mobile-block is-email" onClick={ toggleOpen }>
        { userResources.email }
        <Icon icon="arrow" name="arrow-down" />
      </span>
      <ul className="user-list">
        <li><a href="/meus-pedidos">Meus Pedidos</a></li>
        <li><a href="/fidelidade">Programa de Fidelidade</a></li>
        <li><a href="/meus-projetos">Meus Projetos</a></li>
        <li><a href="/fale-conosco">Atendimento</a></li>
        <li><a onClick={ () => redirectUrl('logout') }>Sair</a></li>
      </ul>
    </Fragment>
  )

  const renderLoggedOut = () => (
    <Fragment>
      <span className="menu-list-mobile-block is-name">
        { renderPicture() }
        <span>
          <a onClick={ () => redirectUrl('login') }>
            <span className="name">Entrar</span>
            <span className="account">Minha conta</span>
          </a>
        </span>
      </span>
    </Fragment>
  )

  return (
    <div className={ userClasses }>
      {
        isLoggedIn
          ? renderLoggIn()
          : renderLoggedOut()
      }
    </div>
  )
}

export default User
